///<reference path="../../docsAndForms/docs-and-forms.models.ts"/>
///<reference path="../../docsAndForms/docs-and-forms-api.service.ts"/>
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.Client {
    'use strict';

    /**
     * NotesSection Section -- need aggregate model for handling functionality.
     */

    import DocsAndFormsApiService = Meevo.Plugins.DocsAndForms.DocsAndFormsApiService;
    import FormFillTypeEnum = Meevo.Plugins.DocsAndForms.FormFillTypeEnum;
    import IClientForm = Meevo.Plugins.DocsAndForms.IClientForm;
    import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;
    import IDocsAndFormsListItem = Meevo.Plugins.DocsAndForms.IDocsAndFormsListItem;
    import IShowFormOptionRow = Meevo.Plugins.DocsAndForms.IShowFormOptionRow;
    import FormAndDocsView = Meevo.Plugins.DocsAndForms.FormAndDocsView;
    import LocationListItem = Meevo.Model.LocationListItem;
    import FormAndDocsDelivery = Meevo.Plugins.DocsAndForms.FormAndDocsDelivery;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;
    import AppointStateEnum = Meevo.Model.AppointStateEnum;


    export interface IGroupedClientForm extends IDocsAndFormsListItem {
        serviceDateTime: string;
        pdfUrl?: string;
        pdfId?: string;
        dateUpdated?: string;
    }

    export class DocsAndFormsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        public View: Array<any> = [
            { value: FormFillTypeEnum.All, label: 'LABEL_ALL_FORMS' },
            { value: FormFillTypeEnum.OnlyOnce, label: 'LABEL_CLIENT_FORMS' },
            { value: FormFillTypeEnum.EveryTime, label: 'LABEL_APPOINTMENT_SERVICE_FORMS' },
            { value: FormFillTypeEnum.Membership, label: 'LABEL_MEMBERSHIP_FORMS' },
        ];

        public historyTransaction: IClientForm[];
        public associatedClientForms: IClientForm[];
        public triggerEventEnum: FormFillTypeEnum;
        public clientDisplayName: string;
        public locations: LocationListItem[] = [];
        public locationId: number;
        public showLocationFilter: boolean;
        public docsAndFormsModuleSecurityAccess: number;
        public docsAndFormsModuleActive: boolean;

        get formFillTypeEnum() {
            return FormFillTypeEnum;
        }

        get hideLocations() {
            return false;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected $cookies: angular.cookies.ICookiesService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $sce,
            sectionSecurityKey: string,
            protected docsAndFormsService: DocsAndFormsService,
            protected $translate: angular.translate.ITranslateService,
            businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService,
                identityService, noun, appSettings, sectionSecurityKey);

            if (!this.identityService.inCentralOfficeMode() && !this.identityService.isSingleLocation()) {
                this.locationId = this.identityService.locationId;
            }

            this.$rootScope.$on(Meevo.Components.Common.Messages.CLOSE_DAF_FORM,
                () => {
                    this.closeForm();
                });

            this.showLocationFilter = false;
            businessInfoDataService
                .getBusinessInfoPreferences()
                .then((settings) => {
                    this.showLocationFilter = settings.clientsSettings.allowViewingDocsAndFormsAcrossLocations;
                });

            securityChecker
                .checkModuleAccess(sectionSecurityKey)
                .then(moduleAccess => {
                    this.docsAndFormsModuleSecurityAccess = moduleAccess;
                    this.docsAndFormsModuleActive = this.docsAndFormsModuleSecurityAccess === SecurityAccessEnum.Grant;
                });
        }

        activate(subSectionContentKey?: string) {
            super.activate(subSectionContentKey);

            this.loadForms();
            this.getLocations();
        }

        loadForms() {
            this.busyService.start();

            this.docsAndFormsService
                .getGroupedClientForms(this.model.id, this.triggerEventEnum)
                .then(res => {
                    const keys: string[] = _.unique(res.map(row => row.securityKey));

                    if (keys.length > 0) {
                        this.securityChecker.checkMany(keys).then(() => this.historyTransaction = res);
                    } else {
                        this.historyTransaction = res;
                    }
                    this.associatedClientForms = res;
                    this.clientDisplayName = this.model.firstName;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        getLocations(): void {
            this.dataService.customMethodData('api/location/list', 'POST', {
                criteria: {
                    filterBySessionUser: true,
                    zipCode: ''
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
                sortDirection: Meevo.Model.SortDirection.Ascending
            })
                .then((response) => {
                    this.locations = response.data;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        closeForm() {
            this.modalService.hide();
        }

        openPdf(url: string) {
            window.open(url, '_blank');
        }

    }
}
